<template>
	<div class="d-flex align-items-center justify-content-center paperout" :class="{ 'error': isEmptyPaper }">
		{{ isEmptyPaper ? 'DOPLN PAPIR - TISK' : 'TISK OK' }}
	</div>
</template>

<script setup>
	import { ref, watch } from 'vue';
	import { storeToRefs } from 'pinia';
	import { useLegacyKioskStore } from '@/stores/legacy/kiosk-store';

	const legacyKioskStore = useLegacyKioskStore();

	const isEmptyPaper = ref(false);
	const { kioskStatus } = storeToRefs(legacyKioskStore);

	watch(kioskStatus, () => {
		const payload = kioskStatus.value?.payload;

		const printer1 = payload?.printer1 === 'PAPER_EMPTY';
		const printer2 = payload?.printer2 === 'PAPER_EMPTY';

		console.log('ServiceView: ', {
			status: kioskStatus.value,
			payload,
			printer1: payload?.printer1,
			printer2: payload?.printer2,
			isEmptyPaper,
		});

		isEmptyPaper.value = printer1 || printer2;
	});
</script>

<style>
	.paperout {
		width: 400px;
		height: 100px;
		color: green;
		border: 1px solid;
	}

	.error {
		color: white;
		background: red;
	}
</style>